// src/modules/finan/components/Menus/InstallmentCreditCardMenu.tsx

import { Menu, MenuItem, ListItemIcon, ListItemText } from "@mui/material";
import {
	DeleteOutline as DeleteOutlineIcon,
	HowToReg,
	PictureAsPdf as PictureAsPdfIcon,
	Sync,
	TableView as TableViewIcon,
	Visibility as VisibilityIcon,
} from "@mui/icons-material";

import { IInstallmentTable } from "../../types/types";

interface Props {
	anchorEl: HTMLElement | null;
	open: boolean;
	onClose: () => void;
	selectedRow: IInstallmentTable | null;
	onOpenModal: (type: "details" | "cancel" | "manual" | "convert", row: IInstallmentTable) => void;
	onExportPdf?: (row: IInstallmentTable) => void;
	onExportCsv?: (row: IInstallmentTable) => void;
}

export const InstallmentCreditCardMenu = ({ anchorEl, open, onClose, selectedRow, onOpenModal, onExportPdf, onExportCsv }: Props) => {
	const handleClick = (type: "details" | "cancel" | "manual" | "convert") => {
		if (selectedRow) {
			onOpenModal(type, selectedRow);
			onClose();
		}
	};

	const handleExport = (action: "pdf" | "csv") => {
		if (!selectedRow) return;
		action === "pdf" ? onExportPdf?.(selectedRow) : onExportCsv?.(selectedRow);
		onClose();
	};

	return (
		<Menu anchorEl={anchorEl} open={open} onClose={onClose}>
			<MenuItem onClick={() => handleClick("details")}>
				<ListItemIcon>
					<VisibilityIcon fontSize="small" />
				</ListItemIcon>
				<ListItemText primary="Visualizar Detalhes" />
			</MenuItem>

			<MenuItem onClick={() => handleExport("pdf")}>
				<ListItemIcon>
					<PictureAsPdfIcon fontSize="small" />
				</ListItemIcon>
				<ListItemText primary="Exportar PDF" />
			</MenuItem>

			<MenuItem onClick={() => handleExport("csv")}>
				<ListItemIcon>
					<TableViewIcon fontSize="small" />
				</ListItemIcon>
				<ListItemText primary="Exportar CSV" />
			</MenuItem>

			<MenuItem onClick={() => handleClick("cancel")}>
				<ListItemIcon>
					<DeleteOutlineIcon fontSize="small" />
				</ListItemIcon>
				<ListItemText primary="Cancelar" />
			</MenuItem>

			<MenuItem onClick={() => handleClick("convert")}>
				<ListItemIcon>
					<Sync fontSize="small" />
				</ListItemIcon>
				<ListItemText primary="Converter Cartão → Boleto" />
			</MenuItem>

			<MenuItem onClick={() => handleClick("manual")}>
				<ListItemIcon>
					<HowToReg fontSize="small" />
				</ListItemIcon>
				<ListItemText primary="Baixar Manualmente" />
			</MenuItem>
		</Menu>
	);
};
